export default __webpack_public_path__ + "static/media/move-arte-7.c9455dee.webp";